Vue.component('Calendar', require('./components/CalendarComponent').default);
